module.exports = __webpack_public_path__ + "img/stub-logo.6abd432c.svg";